import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="angebot" className="scroll-mt-16 bg-brand-alt px-4 py-20 md:py-24" data-id="element-127" data-mp="19gt0ptjsd7a4">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-128" data-mp="1ege0252vbhnd">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-129" data-mp="1j9qnibvt9iej">
          Limitiertes Angebot
        </p>
        <h2 className="mb-12 mt-4 flex items-center justify-center gap-3 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-130" data-mp="1s9n5xvrlxl15">
          <FlameIcon className="h-7 w-7 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-131" data-mp="1x8gmxy63ru62" />
          Spezielles Launch-Angebot
        </h2>
        <div className="rounded-[2rem] border border-brand-line bg-brand-main p-8 shadow-lg md:p-12" data-id="element-132" data-mp="2up5wdlg280l">
          <div className="space-y-4 text-left" data-id="element-133" data-mp="7tiim3swpuzp">
            <PriceLine label="10 komplette Bände (Band 1–10)" price="197 €" data-id="element-134" data-mp="7ubshdn5x0m2" />
            <PriceLine label="5 exklusive Boni" price="130 €" data-id="element-135" data-mp="1mhq2ifzvtqjh" />
            <div className="flex items-center justify-between gap-4 pt-2 text-sm font-extrabold uppercase tracking-wide text-brand-navy" data-id="element-136" data-mp="1hpybk4ctdist">
              <span data-id="element-137" data-mp="1crwpdak3d3d4">Gesamtwert</span>
              <span className="text-brand-gray line-through" data-id="element-138" data-mp="1cosfpxnuxff2">327 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-line py-8" data-id="element-139" data-mp="17ppc8hnizh97">
            <p className="font-display text-6xl font-extrabold tracking-tight text-brand-orange md:text-7xl" data-id="element-140" data-mp="25e7sosz31idm">
              19 €{' '}
              <span className="text-2xl font-bold text-brand-navy" data-id="element-141" data-mp="20emrsd0cqzy9">EUR</span>
            </p>
          </div>
          <CTAButton animated href="https://kunst-startklar.impultienda.ar/checkout" className="w-full py-5" data-id="element-142" data-mp="1rfrksyphhltw" />
          <p className="mt-5 text-xs font-semibold text-brand-gray" data-id="element-143" data-mp="k2zc5luqlwr8">
            Einmalige Zahlung · Sofort-Download · Sichere Bezahlung
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-line pb-4 text-sm" data-id="element-144" data-mp="mftbxifi2wym">
      <span className="font-medium" data-id="element-145" data-mp="7ik6xlx9xuof">{label}</span>
      <span className="shrink-0 font-bold text-brand-gray line-through" data-id="element-146" data-mp="7ly66lan5nrn">
        {price}
      </span>
    </div>;
}